export const environment = {
  production: false,
  markBaseUrl:
    location.hostname.indexOf('localhost') > -1
      ? 'http://192.168.7.233:8011/v2'
      : `${location.protocol}//${location.host}/v2`,
  scanImgBaseUrl: 'https://demo-1251808174.cos.ap-chengdu.myqcloud.com/media/',
  sketchUrl: 'https://s-test.100tifen.com/module/edoc/index.html#/sketch?--noToken',
  officeWeb365Key: '35869',
  templateDesigner: 'http://s-test.100tifen.com/module/gemini/index.html',
};
